<!-- Language Toggle-->

@if (!isLoggingIn) {
  <div class="row align-items-center">
    <div class="col d-flex gap-2" align="left">
      <button mat-stroked-button type="button" (click)="toResources()">
        <mat-icon>menu_book</mat-icon>
        <span i18n>Resources</span>
      </button>
      <button mat-stroked-button type="button" (click)="toHelp()">
        <mat-icon>help_outline</mat-icon>
        <span i18n>Help</span>
      </button>
    </div>

    <div class="col" align="right">
      <app-language-toggle></app-language-toggle>
    </div>
  </div>
}

<!-- Loading Screen -->

@if (isLoggingIn) {
  <div class="wrapper center-1"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Login Page -->

@if (!isLoggingIn) {
  <div class="container login-container"
    >
    <!-- Archipelago logo -->
    <div class="row justify-content-center">
      <div class="col login-image">
        <img [src]="('assets/images/archipelago-blue-email.png' | sanitizeUrl)" class="center" width="300" />
      </div>
    </div>
    <!-- Page title -->
    <div class="row">
      <h1 i18n class="login-title">
      Login
    </h1>
    </div>
    <div class="row">
      <h2 i18n class="login-subtitle">
      You are currently {onlineStatus, select, online {online} offline {offline}}
    </h2>
    </div>
    <form [formGroup]="loginForm" class="row">
      <mat-form-field appearance="outline">
        <mat-label i18n>
        Email
      </mat-label>
        <input matInput
          required
          formControlName="email">
          <mat-error i18n>
        {emailError, select, Invalid email format {Invalid email format} Required {Required}}
      </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label i18n>
        Password
      </mat-label>
          <input matInput
            required
            formControlName="password"
            [type]="passwordHide ? 'password' : 'text'"
            (keyup.enter)="attemptLogin()">
            <button mat-icon-button
              matSuffix
              type="button"
              (click)="passwordHide = !passwordHide">
              <mat-icon>
                {{passwordHide ? 'visibility_off' : 'visibility'}}
              </mat-icon>
            </button>
            @if (this.loginForm.get('password')?.invalid) {
              <mat-error i18n>
        Required
      </mat-error>
            }
          </mat-form-field>
        </form>
        @if (onlineBoolean) {
          <div class="form-inline" align="right"> <p i18n style="font-size:medium; font-weight: bold"> <a id="forgot" role="button" data-bs-toggle="modal" data-bs-target="#exampleModal" class="font-weight-bold">Forgot Password?</a> </p> </div>
        }
        @if (!onlineBoolean) {
          <div class="form-inline" align="right"> <p i18n style="font-size:medium; font-weight: bold"><s>Forgot Password?</s><br />Must be online to reset password </p> </div>
        }
        <div class="row justify-content-center">
          <button i18n mat-flat-button
            class="login-button"
            (keyup.enter)="attemptLogin()"
            (click)="attemptLogin()">
      Login
    </button>
        </div>
        <div class="row justify-content-center bottom-row" align="center">
          <p i18n style="font-size:medium; font-weight: bold; color: #003F61;">
      New to Salmon eLog?
      <a routerLink="/sign-up" routerLinkActive="active" ariaCurrentWhenActive="page">
        Sign Up
      </a>
          </p>
          <p class="version-label">v{{ appVersion }}</p>
        </div>
      </div>
    }


    <!-- Reset Password Pop Up Dialog Box -->

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="exampleModalLabel">
              <span i18n style="font-size: 25px;font-weight:700">Forgot your password?</span><br />
              <small i18n>Please enter your email</small>
            </p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="form-group pt-3">
              <div class="input-field"> <span class="fade"></span> <input [(ngModel)]="resetPasswordEmail" (ngModelChange)="checkValidEmail($event)" type="text" placeholder="Email" i18n-placeholder="Email placeholder" /> </div>
            </div>
            @if (!resetPasswordEmail) {
              <small i18n class="text-danger">Email is required</small>
            }
            @if (!isValidEmail && resetPasswordEmail) {
              <small i18n class="text-danger">Email is invalid</small>
            }
          </div>
          <div class="modal-footer">
            <button i18n id="closeBtn" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button i18n type="button" (click)="confirmToSend()" class="btn btn-primary">Send</button>
          </div>
        </div>
      </div>
    </div>
